export * from "./connect-problems.generated.js";
export * from "./files.js";
export * from "./operations.js";
export * from "./mutation-fingerprint.js";
export * from "./compatibility.js";
export * from "./capabilities.js";
export * from "./application-authorization.js";
export * from "./type-packs.js";
export * from "./collection-setup.js";
export const CONTROL_PROTOCOL_VERSION = 1;
export { AUTHORIZATION_BINDING_PROTOCOL_VERSION as APPLICATION_AUTHORIZATION_PROTOCOL_VERSION } from "./compatibility.js";
export const LOOPBACK_PROTOCOL_VERSION = 1;
export const DEFAULT_LOOPBACK_PORT = 28_485;
export const RELAY_ENCRYPTION_SUITE = "P256-HKDF-SHA256-AES256GCM";
export const GRANT_ENCRYPTION_PROTOCOL_VERSION = 1;
export const SYNC_PROTOCOL_VERSION = 1;
export const CONTRACT_SETUP_CAPABILITY = "contract-setup-v1";
export const FILE_RELAY_CAPABILITY = "file-relay-v1";
export const PROTOCOL_USAGE_REPORT_CAPABILITY = "protocol-usage-report-v1";
export const RELAY_REQUIRED_CAPABILITIES = [
    "application-authorization-v4",
    "authorization-activation",
    "encrypted-relay",
    "policy-ack"
];
export const MINIMUM_CONNECTOR_VERSION = "0.1.0-beta.33";
export const HOSTED_PROVIDER_REQUIRED_CAPABILITIES = [
    "durable-mutation-journal-v1",
    "durable-file-lifecycle-v1"
];
export const HOSTED_CANDIDATE_B_ACTIVATION_CAPABILITY = "candidate-b-activation-v1";
export const HOSTED_PROVIDER_CAPABILITIES = [
    ...HOSTED_PROVIDER_REQUIRED_CAPABILITIES,
    "mutation-replay-after-credential-retirement-v1",
    HOSTED_CANDIDATE_B_ACTIVATION_CAPABILITY
];
export const RELAY_CAPABILITIES = [
    ...RELAY_REQUIRED_CAPABILITIES,
    "application-authorization-v5",
    CONTRACT_SETUP_CAPABILITY,
    FILE_RELAY_CAPABILITY,
    PROTOCOL_USAGE_REPORT_CAPABILITY
];
export const AUTHORITY_PROOF_VERSION = 1;
export const AUTHORITY_PROOF_ALGORITHM = "P256-SHA256";
export const AUTHORITY_PROOF_DOMAIN = "mdbase-authority-request-proof-v1";
export const AUTHORITY_PROOF_HEADERS = {
    version: "x-mdbase-proof-version",
    timestamp: "x-mdbase-proof-timestamp",
    nonce: "x-mdbase-proof-nonce",
    signature: "x-mdbase-proof-signature"
};
/**
 * Validate a native OAuth callback against the publisher of its web manifest.
 * Reverse-domain private-use schemes keep native app identity tied to the
 * manifest origin; PKCE remains mandatory at the authorization boundary.
 */
export function isNativeRedirectUri(url, publisherHostname) {
    const scheme = url.protocol.slice(0, -1);
    const publisherPrefix = publisherHostname
        ?.toLowerCase()
        .split(".")
        .reverse()
        .join(".");
    return scheme.includes(".")
        && /^[a-z][a-z0-9+.-]*$/.test(scheme)
        && !["http", "https", "file", "javascript", "data"].includes(scheme)
        && (!publisherPrefix
            || scheme === publisherPrefix
            || scheme.startsWith(`${publisherPrefix}.`))
        && url.username === ""
        && url.password === ""
        && url.hostname.length > 0
        && url.hash === "";
}
export const CONNECT_SCHEMA_IDS = {
    appManifest: "https://mdbase.dev/connect/schemas/mdbase-app.v1.json",
    notificationWebhook: "https://mdbase.dev/connect/schemas/notification-webhook.v1.json",
    dataContract: "https://mdbase.dev/schemas/v0.3/data-contract.schema.json",
    eventActionInterop: "https://mdbase.dev/schemas/interop/v0.1/profile.schema.json",
    protocol: "https://mdbase.dev/connect/schemas/connect-protocol.v1.json",
    encryptedRelay: "https://mdbase.dev/connect/schemas/encrypted-relay.v3.json",
    files: "https://mdbase.dev/connect/schemas/files.v1.json",
    sync: "https://mdbase.dev/connect/schemas/sync.v1.json"
};
